import * as React from "react";

export const SvgVariant = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M18 12.666v3.556c0 .982-.795 1.778-1.777 1.778H3.778A1.778 1.778 0 0 1 2 16.222v-3.556M14.444 6.445 9.999 2 5.555 6.445M10 2v10.667"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
